import api from '../../schedulerApi';

const useHttpPostDeviceDailyModeConfig = () => {
    const post = async (device_id, daily_bp_id, configs) => {
        try {
            const response = await api.post_device_daily_mode_config(device_id, daily_bp_id, configs);
            return response;
        } catch (error) {
            console.error('Error updating daily blueprint:', error?.response?.data || error.message);
            throw error;
        }
    };

    return post;
};

export default useHttpPostDeviceDailyModeConfig;
